function variable (variable) {
  return '?' + variable.value
}

module.exports = variable
